/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { LuisId } from 'src/luis/types/Resource';
import { EntityRoleStore } from 'src/luis/types/stores/entities/EntityRoleStore';

/**
 * An entity role store factory function.
 *
 * @param id The id of the entity role to create.
 * @param role The entity role data.
 * @returns A new instance of an entity role store.
 */
export const createEntityRoleStore = (id: LuisId, role: Partial<EntityRoleStore>): EntityRoleStore => {
    const roleStore: EntityRoleStore = {
        id,
        name: role.name,

        /**
         * Renames the entity role with the given name.
         *
         * @param name The name to rename the entity role with.
         */
        rename(name) {
            this.name = name;
        }
    };

    return observable(roleStore, { name: observable, rename: action }, { deep: false });
};
